import React, { useState } from "react";
import { Tabs, Tab, InputGroup } from "react-bootstrap";
import DataModelChildGroupComponent from "../DataModelChildGroupComponent";
import FormControlSearch from "../FormControlSearch";
import { Form } from "formik";
import SearchBar from "./../../containers/Mapper/LoadDefHomeContainer/SearchBar";

const SourceFieldPanelComponent = (props) => {
  const {
    sections,
    handleOnDragEnd,
    clickToSelect,
    fieldArrayName,
    showSource = true,
    headerValueKey,
  } = props;

  const [keyValue, setKeyValue] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [sectionFields, setSectionFields] = useState(
    sections ? sections[0]?.fields : []
  );
  const [list, setList] = useState(sections ? sections[0]?.fields : []);

  const tabChange = (key) => {
    setKeyValue(key);
    let fields = sections ? sections[key]?.fields : [];
    setSectionFields(fields);
    setList(fields);
  };

  const handleChange = (e) => {
    setSectionFields(
      list?.filter((c) =>
        c.propertyName.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  const searchItems = (searchValue) => {
    setSearchInput(searchValue);
    if (searchInput !== "") {
      const filteredData = list.filter((item) => {
        return Object.values(item.propertyName || item.displayName)
          .join("")
          .toLowerCase()
          .includes(searchInput.toLowerCase());
      });
      setSectionFields(filteredData);
    } else {
      setSectionFields(list);
    }
  };

  return (
    <>
      {showSource && (
        <div className="source-field-panel-component">
          <div
            style={{
              fontWeight: "500",
              alignItems: "center",
              paddingBottom: "0",
            }}
          >
            Select Source fields to map
          </div>
          <div className="line-separator-new"></div>
          <div style={{ marginBottom: "2rem" }}>
            <Tabs
              activeKey={keyValue}
              transition={false}
              onSelect={tabChange}
              className="source-field-tabs"
              mountOnEnter
              unmountOnExit
            >
              {sections?.map((item, index) => {
                return (
                  <Tab
                    eventKey={index}
                    style={{ borderColor: "transparent" }}
                    title={
                      <span style={{ whiteSpace: "nowrap" }}>{item.name}</span>
                    }
                  />
                );
              })}
            </Tabs>
          </div>
          <div>
            <span className="search-field">Select Source field</span>
            <div style={{ paddingBottom: "1rem" }}>
              <input
                icon="search"
                className="search-bar"
                placeholder="Search source fields here"
                onChange={(e) => searchItems(e.target.value)}
              />
            </div>
          </div>
          <DataModelChildGroupComponent
            characters={sectionFields}
            setCharacters={setSectionFields}
            handleOnDragEnd={handleOnDragEnd}
            clickToSelect={clickToSelect}
            fieldArrayName={fieldArrayName}
            headerValueKey={headerValueKey}
          />
        </div>
      )}
    </>
  );
};

export default SourceFieldPanelComponent;
